(() => {
  if (!document.querySelector('.village-refined')) return;
  let queued = false;
  const updateHelp = () => {
    queued = false;
    const launcher = document.querySelector('.spice-help__launcher');
    if (!launcher) return;
    const mobile = window.matchMedia('(max-width: 767.98px)').matches;
    const button = launcher.getBoundingClientRect();
    const controls = document.querySelectorAll('.section-main-product .product__title, .section-main-product .refined-price, .section-main-product .product-form__buttons, .sticky-atc-bar');
    const overlaps = mobile && Array.from(controls).some((control) => {
      const box = control.getBoundingClientRect();
      return box.width > 0 && box.height > 0 && box.left < button.right && box.right > button.left && box.top < button.bottom + 8 && box.bottom > button.top - 8;
    });
    launcher.classList.toggle('refined-help-obscures-purchase', overlaps);
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(updateHelp);
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
  schedule();
})();
